import { MyInjector } from "@src/app/app.module";
import { CurrentUserService } from "@src/app/modules/user/current-user.service";
import { ConfirmDialogService } from "@src/app/shared/dialogs/confirmDialog";
import { ActionColor, IFormAction } from "@src/app/shared/form/form.component";
import { PersonService } from "@src/app/pages/person-page/person.service";
import { MatDialog } from "@angular/material/dialog";
import { FormEmailComponent } from "@src/app/shared/form/form-email/form-email.component";
import { required } from "@src/app/shared/validators";
import { Person } from "@src/app/model/person";
import { Observable } from "rxjs";
import { FieldSet, LAYOUT_OPTIONS } from "@src/app/shared/form/field-set/field-set.component";
import { FieldSetDialogComponent, FieldSetDialogOptions } from "@src/app/shared/dialogs/field-set-dialog/field-set-dialog.component";
import { AbstractObject } from "@src/app/model/abstract-object";

/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
export class UpdateEmailAction implements IFormAction {
    name = $localize`Edit Email Address`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'edit_square';
    approvalNeeded = false;
    disabled = false;
    approvalText = '';
    tipText = "Update the email address for this contact";

    cds = MyInjector.instance.get(ConfirmDialogService);

    currentUser = MyInjector.instance.get(CurrentUserService).currentUser;
    personService = MyInjector.instance.get(PersonService);
    dialog = MyInjector.instance.get(MatDialog);


    emailField = FormEmailComponent.make('New Email Address', 'email', { validators: [required] });

    private person: Person;

    action() { // config: FormConfig
        return this.doAction();
    }

    doAction() : Observable<Person>{
        return this.openSendMailDialog();
    }

    setup(item: Person) {
        this.person = item;
        this.show = true;
    }

    updateEmailAddress() : Observable<Person> {
        return this.personService.updateEMail(this.person, this.emailField.getFormValue());
    }


    openSendMailDialog() {
        const fieldSet = new FieldSet({
            fields: [
                this.emailField,
            ],
            formLayout: LAYOUT_OPTIONS.simpleDialog
        })
        fieldSet.setValue({} as AbstractObject, false); // Need to set a value to set it up.
        const data = {
            fieldSet,
            saveFn: this.updateEmailAddress.bind(this),
            saveText: 'Update',
            title: 'Update Email Address For ' +this.person.fullName,
        } as FieldSetDialogOptions

        return this.dialog.open(FieldSetDialogComponent, {data} ).afterClosed();
    }
}
